{
  "pages": {
    "list": "Lịch hẹn",
    "calendar": "Lịch hẹn",
    "kanban": "Lịch hẹn",
    "addTitle": "Đặt lịch hẹn mới",
    "addTitleWithPatient": "Đặt lịch hẹn: {{name}}",
    "addTitleWithLead": "Đặt lịch hẹn: {{name}}",
    "editTitle": "Sửa lịch hẹn",
    "editTitleWithPatient": "Sửa lịch hẹn: {{name}}",
    "editTitleWithLead": "Sửa lịch hẹn: {{name}}",
    "detailsTitle": "Chi tiết lịch hẹn",
    "requiredFieldsNote": "Các trường có dấu * là bắt buộc",
    "patientInformation": "Thông tin bệnh nhân",
    "appointmentDetails": "Chi tiết lịch hẹn",
    "schedulePanel": "Chọn ngày và giờ",
    "loadingAppointmentData": "Đang tải dữ liệu lịch hẹn...",
    "backToAppointments": "Quay lại danh sách lịch hẹn",
    "appointmentNotFound": "Không tìm thấy lịch hẹn hoặc dữ liệu chưa được tải",
    "notFound": "Không tìm thấy lịch hẹn",
    "invalidId": "Mã lịch hẹn không hợp lệ.",
    "permissionDenied": "Bạn không có quyền xem danh sách lịch hẹn.",
    "createPermissionDenied": "Bạn không có quyền đặt lịch hẹn mới.",
    "editPermissionDenied": "Bạn không có quyền sửa lịch hẹn.",
    "searchPlaceholder": "Tìm kiếm lịch hẹn...",
    "noAppointmentsFound": "Không tìm thấy lịch hẹn nào"
  },

  "schedule": {
    "pickDate": "Chọn ngày",
    "pickTime": "Chọn giờ bắt đầu",
    "selectClinicDoctorHint": "Chọn phòng khám để xem ngày có thể đặt (chọn bác sĩ để thu hẹp theo ca làm việc)",
    "selectClinicHint": "Chọn phòng khám để xem ngày có thể đặt",
    "loadingDays": "Đang tải ngày làm việc…",
    "loadingTimes": "Đang tải khung giờ…",
    "loadDaysFailed": "Không tải được lịch ngày làm việc",
    "loadTimesFailed": "Không tải được khung giờ trống",
    "pickDateFirst": "Chọn ngày để xem giờ bắt đầu",
    "pickDoctorForTimes": "Chọn bác sĩ để xem khung giờ",
    "noTimesAvailable": "Không còn khung giờ trống trong ngày này",
    "timeWarnHint": "Khung giờ này trùng lịch — có thể đặt sau khi xác nhận",
    "doctorBusyHint": "Bác sĩ đang bận khung giờ đã chọn",
    "doctorNotWorkingHint": "Bác sĩ không làm việc ngày này",
    "conflictPreviewTitle": "Cảnh báo trùng lịch",
    "conflictPreviewBody": "Khung giờ đã chọn chồng với lịch khác theo chính sách phòng khám. Bạn vẫn có thể lưu và xác nhận ở bước tiếp theo.",
    "prefillWarnBanner": "Khung giờ được chọn từ lịch đang có cảnh báo trùng — khi lưu bạn sẽ cần xác nhận.",
    "reasons": {
      "date_in_past": "Không thể đặt lịch vào ngày đã qua",
      "clinic_not_found": "Không tìm thấy phòng khám",
      "clinic_closed": "Phòng khám đóng cửa ngày này",
      "staff_not_found": "Không tìm thấy bác sĩ",
      "schedule_not_configured": "Bác sĩ chưa được cấu hình lịch làm việc",
      "staff_not_working": "Bác sĩ không làm việc ngày này",
      "staff_all_day_time_off": "Bác sĩ nghỉ phép cả ngày",
      "outside_advance_window": "Ngày này vượt quá giới hạn đặt trước tối đa",
      "outside_lead_window": "Ngày này nằm trong khoảng thời gian đặt trước tối thiểu"
    }
  },

  "fields": {
    "id": "Mã",
    "patient": "Bệnh nhân",
    "selectPatient": "Chọn bệnh nhân",
    "patientSearchPlaceholder": "Tìm tên / SĐT",
    "subjectPatient": "Bệnh nhân",
    "subjectLead": "Lead",
    "selectLead": "Chọn lead",
    "leadSearchPlaceholder": "Tìm lead theo tên / SĐT",
    "searchTypeMore": "Nhập ít nhất 2 ký tự",
    "leadSearchNoResults": "Không tìm thấy lead",
    "createNewPatient": "Tạo bệnh nhân mới",
    "createNewType": "Tạo loại lịch hẹn mới",
    "createNewTreatment": "Tạo dịch vụ mới",
    "createNewLead": "Tạo lead mới",
    "doctor": "Bác sĩ",
    "doctorPlaceholder": "Chọn bác sĩ",
    "loadingDoctors": "Đang tải danh sách bác sĩ…",
    "selectDoctor": "Bác sĩ",
    "clinic": "Phòng khám",
    "clinicPlaceholder": "Chọn phòng khám",
    "date": "Ngày",
    "appointmentDate": "Ngày hẹn",
    "time": "Giờ",
    "startTime": "Giờ bắt đầu",
    "startTimePlaceholder": "09:30",
    "endTime": "Giờ kết thúc",
    "endTimeAutoPlaceholder": "Tự động tính",
    "duration": "Thời lượng",
    "durationInMinutes": "Thời lượng (phút)",
    "durationPlaceholder": "Nhập số phút",
    "durationMinutes": "{{count}} phút",
    "type": "Loại lịch hẹn",
    "typePlaceholder": "Chọn loại lịch hẹn",
    "visitKind": "Phân loại lịch",
    "visitKindPlaceholder": "Chọn phân loại lịch",
    "chair": "Ghế nha",
    "chairPlaceholder": "Chọn ghế",
    "status": "Trạng thái",
    "statusPlaceholder": "Chọn trạng thái",
    "reasonForVisit": "Lý do khám",
    "reasonPlaceholder": "Nhập lý do khám",
    "notes": "Ghi chú",
    "notesPlaceholder": "Thêm ghi chú",
    "treatment": "Dịch vụ điều trị",
    "treatmentPlaceholder": "Chọn dịch vụ điều trị",
    "noTreatment": "Không có điều trị",
    "customerSource": "Nguồn khách hàng",
    "cancelReason": "Lý do hủy",
    "appointmentCode": "Mã lịch hẹn",
    "appointmentCodePrefix": "Mã lịch hẹn: {{code}}",
    "dateTime": "Ngày & Giờ",
    "arrivedAt": "Thời điểm tiếp nhận",
    "checkedInBy": "Người tiếp nhận",
    "createdAt": "Ngày tạo",
    "updatedAt": "Cập nhật lần cuối",
    "specialization": "Chuyên khoa",
    "phone": "Số điện thoại",
    "email": "Email",
    "address": "Địa chỉ",
    "name": "Họ tên"
  },

  "actions": {
    "newAppointment": "Lịch hẹn",
    "addAppointment": "Lịch hẹn",
    "scheduleAppointment": "Đặt lịch hẹn",
    "scheduling": "Đang đặt lịch...",
    "updateAppointment": "Cập nhật lịch hẹn",
    "updating": "Đang cập nhật...",
    "viewPatientProfile": "Xem hồ sơ bệnh nhân",
    "viewLead": "Xem lead",
    "refresh": "Làm mới",
    "import": "Nhập file",
    "export": "Xuất file",
    "moreActions": "Thêm hành động",
    "busyTime": "Thời gian bận",
    "columns": "Cột",
    "resetColumns": "Đặt lại cột",
    "backToAppointments": "Quay lại lịch hẹn",
    "viewDetails": "Xem chi tiết",
    "call": "Gọi",
    "message": "Nhắn",
    "createTask": "Tạo việc",
    "openTreatmentPlan": "Kế hoạch điều trị",
    "openPrescription": "Đơn thuốc",
    "openReceipt": "Phiếu thu",
    "checkIn": "Tiếp nhận",
    "advanceToStatus": "Chuyển sang {{status}}",
    "editAppointment": "Chỉnh sửa",
    "deleteAppointment": "Xóa lịch hẹn"
  },

  "filters": {
    "filter": "Lọc",
    "filters": "Bộ lọc",
    "filterAppointments": "Lọc lịch hẹn",
    "clearAll": "Xóa tất cả",
    "reset": "Đặt lại",
    "applyFilters": "Áp dụng",
    "allTypes": "Tất cả loại",
    "allStatuses": "Tất cả trạng thái",
    "allClinics": "Tất cả phòng khám",
    "allDoctors": "Tất cả bác sĩ",
    "allChairs": "Tất cả ghế",
    "dateRange": "Khoảng ngày hẹn",
    "dateRangePlaceholder": "Chọn khoảng ngày hẹn",
    "dateRangeMaxDays": "Tối đa {{count}} ngày",
    "timeRange": "Khoảng giờ hẹn",
    "timeFrom": "Từ",
    "timeTo": "Đến",
    "selectClinicForChair": "Chọn phòng khám để lọc theo ghế"
  },

  "filterTypes": {
    "checkup": "Khám tổng quát",
    "cleaning": "Làm sạch răng",
    "consultation": "Tư vấn",
    "followUp": "Tái khám",
    "treatment": "Điều trị",
    "emergency": "Cấp cứu"
  },

  "visitKind": {
    "new": "Lịch mới",
    "followUp": "Tái khám",
    "unclassified": "Chưa phân loại"
  },

  "validation": {
    "patientRequired": "Vui lòng chọn bệnh nhân",
    "leadRequired": "Vui lòng chọn lead",
    "doctorRequired": "Vui lòng chọn bác sĩ",
    "clinicRequired": "Vui lòng chọn phòng khám",
    "dateRequired": "Vui lòng chọn ngày hẹn",
    "startTimeRequired": "Vui lòng nhập giờ bắt đầu",
    "durationRequired": "Vui lòng nhập thời lượng",
    "durationMin": "Thời lượng tối thiểu 15 phút",
    "typeRequired": "Vui lòng chọn loại lịch hẹn",
    "visitKindRequired": "Vui lòng chọn phân loại lịch",
    "chairRequired": "Vui lòng chọn ghế nha",
    "statusRequired": "Vui lòng chọn trạng thái",
    "reasonRequired": "Vui lòng nhập lý do khám",
    "reasonMaxLength": "Lý do khám tối đa 200 ký tự",
    "notesMaxLength": "Ghi chú tối đa 500 ký tự",
    "cancelReasonRequired": "Vui lòng nhập lý do hủy",
    "cancelReasonMaxLength": "Lý do hủy tối đa 100 ký tự"
  },

  "unsavedChanges": {
    "title": "Rời trang?",
    "body": "Bạn có thay đổi chưa lưu. Nếu rời trang, các thay đổi sẽ bị mất.",
    "stay": "Ở lại",
    "leave": "Rời trang"
  },

  "toasts": {
    "loadFailed": "Không thể tải danh sách lịch hẹn",
    "loadFailedRetry": "Không thể tải danh sách lịch hẹn. Vui lòng thử lại.",
    "loadDataFailed": "Không thể tải dữ liệu",
    "loadDataFailedRetry": "Không thể tải dữ liệu cần thiết. Vui lòng thử lại.",
    "loadAppointmentDataFailed": "Không thể tải dữ liệu lịch hẹn",
    "loadAppointmentDataFailedRetry": "Không thể tải dữ liệu lịch hẹn. Vui lòng thử lại.",
    "loadDoctorsFailed": "Không thể tải danh sách bác sĩ",
    "authTokenNotFound": "Không tìm thấy mã xác thực",
    "deleteSuccess": "Xóa lịch hẹn thành công",
    "deleteFailed": "Không thể xóa lịch hẹn",
    "addSuccess": "Đặt lịch hẹn thành công!",
    "addFailed": "Không thể đặt lịch hẹn",
    "addFailedRetry": "Không thể đặt lịch hẹn. Vui lòng thử lại.",
    "updateSuccess": "Cập nhật lịch hẹn thành công",
    "updateFailed": "Không thể cập nhật lịch hẹn",
    "updateFailedRetry": "Không thể cập nhật lịch hẹn. Vui lòng thử lại.",
    "statusUpdateSuccess": "Cập nhật trạng thái lịch hẹn thành công",
    "checkInSuccess": "Đã tiếp nhận bệnh nhân",
    "checkInFailed": "Không thể tiếp nhận",
    "statusUpdateFailed": "Không thể cập nhật trạng thái lịch hẹn",
    "invalidStatusTransition": "Không thể chuyển sang trạng thái này",
    "provideCancelReason": "Vui lòng nhập lý do hủy",
    "fillRequiredFields": "Vui lòng điền đầy đủ các trường bắt buộc",
    "filtersApplied": "Áp dụng bộ lọc thành công",
    "exported": "Đã xuất danh sách lịch hẹn",
    "exportFailed": "Không xuất được danh sách lịch hẹn",
    "imported": "Đã nhập lịch hẹn",
    "importFailed": "Không nhập được danh sách lịch hẹn",
    "templateFailed": "Không tải được file mẫu"
  },

  "importExport": {
    "hintRequired": "Bắt buộc: chi nhánh, bác sĩ, loại lịch, ngày hẹn (YYYY-MM-DD), giờ (HH:mm), và đúng một trong mã bệnh nhân hoặc SĐT lead.",
    "hintSubject": "patientId là mã bệnh nhân (PA…). leadPhone là SĐT lead đang mở. Không điền cả hai trên cùng một dòng.",
    "hintCodes": "clinicBranchCode / staffCode / appointmentTypeCode / chairCode / treatmentCode phải khớp mã đã có. Ghế bắt buộc nếu phòng khám yêu cầu ghế.",
    "hintDate": "Ngày giờ theo múi giờ phòng khám. duration (phút, tối thiểu 15) trống thì lấy thời lượng mặc định của loại lịch.",
    "hintStatus": "status chỉ scheduled hoặc confirmed (trống = scheduled). appointmentCode trong file bị bỏ qua — hệ thống cấp mã mới. Trùng slot (cùng người + bác sĩ + phòng khám + giờ bắt đầu) sẽ lỗi.",
    "hintMapping": "Tên cột không cần giống file mẫu — hãy ghép cột sau khi chọn file, rồi bấm Kiểm tra.",
    "hintSheet": "File Excel: chỉ nhập sheet đầu tiên; các sheet khác bị bỏ qua.",
    "chooseFile": "Chọn file CSV hoặc Excel",
    "dropHint": "Nhấn để chọn hoặc kéo thả file CSV hoặc Excel",
    "acceptHint": "CSV hoặc Excel (.xlsx), tối đa 20MB / 2000 dòng. Excel: chỉ đọc sheet đầu.",
    "invalidFile": "Vui lòng chọn file CSV hoặc Excel (.xlsx)",
    "changeFile": "Đổi file",
    "commit": "Nhập dữ liệu",
    "downloadTemplate": "Tải file mẫu",
    "downloadErrors": "Tải dòng lỗi (CSV)",
    "errorsCsvFilename": "lich-hen-loi.csv",
    "noFile": "Vui lòng chọn file CSV hoặc Excel",
    "previewTitle": "Kết quả kiểm tra",
    "total": "Tổng dòng",
    "toCreate": "Sẽ tạo mới",
    "toUpdate": "Sẽ cập nhật",
    "errorsTitle": "Lỗi",
    "row": "Dòng",
    "code": "Mã",
    "message": "Chi tiết",
    "readyToCommit": "File hợp lệ. Bạn có thể nhập dữ liệu.",
    "hasErrors": "File còn lỗi. Sửa rồi kiểm tra lại trước khi nhập.",
    "resultTitle": "Kết quả nhập",
    "created": "Đã tạo",
    "updated": "Đã cập nhật",
    "uploading": "Đang tải file…",
    "checking": "Đang kiểm tra file…",
    "checkingWithCount": "Đang kiểm tra {{count}} dòng…",
    "importing": "Đang nhập dữ liệu…",
    "importingWithCount": "Đang nhập {{count}} dòng…",
    "fields": {
      "patientId": "Mã bệnh nhân",
      "leadPhone": "SĐT lead",
      "clinicBranchCode": "Mã chi nhánh",
      "staffCode": "Mã bác sĩ",
      "appointmentTypeCode": "Loại lịch",
      "appointmentDate": "Ngày hẹn",
      "startTime": "Giờ bắt đầu",
      "duration": "Thời lượng (phút)",
      "chairCode": "Mã ghế",
      "status": "Trạng thái",
      "reasonForVisit": "Lý do khám",
      "notes": "Ghi chú",
      "treatmentCode": "Mã điều trị"
    },
    "rowErrors": {
      "SUBJECT_REQUIRED": "Cần patientId hoặc leadPhone (chỉ một).",
      "SUBJECT_AMBIGUOUS": "Chỉ điền một trong patientId hoặc leadPhone.",
      "PATIENT_UNKNOWN": "Không tìm thấy mã bệnh nhân {{patientId}}.",
      "PATIENT_PURGED": "Mã {{patientId}} thuộc hồ sơ đã xóa vĩnh viễn.",
      "PATIENT_ARCHIVED": "Mã {{patientId}} thuộc hồ sơ đang lưu trữ.",
      "LEAD_PHONE_INVALID": "Số điện thoại lead không hợp lệ.",
      "LEAD_UNKNOWN": "Không tìm thấy lead với SĐT {{leadPhone}}.",
      "LEAD_AMBIGUOUS": "SĐT {{leadPhone}} khớp nhiều hơn một lead.",
      "LEAD_CLOSED": "Không đặt lịch cho lead đã đóng ({{leadPhone}}).",
      "CLINIC_REQUIRED": "Thiếu mã chi nhánh (clinicBranchCode).",
      "CLINIC_UNKNOWN": "Không tìm thấy mã chi nhánh {{clinicBranchCode}}.",
      "CLINIC_INACTIVE": "Mã chi nhánh {{clinicBranchCode}} đang ngừng hoạt động.",
      "CLINIC_OUT_OF_SCOPE": "Mã chi nhánh {{clinicBranchCode}} nằm ngoài phạm vi phòng khám hiện tại.",
      "STAFF_REQUIRED": "Thiếu mã bác sĩ (staffCode).",
      "STAFF_UNKNOWN": "Không tìm thấy mã bác sĩ {{staffCode}}.",
      "STAFF_NOT_AT_CLINIC": "Bác sĩ {{staffCode}} không làm việc tại chi nhánh {{clinicBranchCode}}.",
      "TYPE_REQUIRED": "Thiếu mã loại lịch (appointmentTypeCode).",
      "TYPE_UNKNOWN": "Không tìm thấy loại lịch {{appointmentTypeCode}}.",
      "TYPE_INACTIVE": "Loại lịch {{appointmentTypeCode}} đang ngừng dùng.",
      "DATETIME_INVALID": "appointmentDate phải là YYYY-MM-DD và startTime phải là HH:mm.",
      "DURATION_INVALID": "duration phải là số nguyên, tối thiểu 15 phút.",
      "CHAIR_UNKNOWN": "Không tìm thấy ghế {{chairCode}} tại phòng khám này.",
      "CHAIR_INACTIVE": "Ghế {{chairCode}} đang ngừng dùng.",
      "CHAIR_REQUIRED": "Phòng khám này bắt buộc chọn ghế (chairCode).",
      "STATUS_INVALID": "status chỉ được scheduled hoặc confirmed.",
      "REASON_TOO_LONG": "reasonForVisit không được vượt quá {{max}} ký tự.",
      "NOTES_TOO_LONG": "notes không được vượt quá {{max}} ký tự.",
      "TREATMENT_UNKNOWN": "Không tìm thấy mã điều trị {{treatmentCode}}.",
      "TREATMENT_INACTIVE": "Mã điều trị {{treatmentCode}} đang ngừng dùng.",
      "DUPLICATE_SLOT": "Đã có lịch cùng bệnh nhân/lead, bác sĩ, phòng khám và giờ bắt đầu.",
      "DUPLICATE_SLOT_IN_FILE": "Dòng này trùng slot với dòng khác trong file.",
      "FILE_OVERLAP": "Khung giờ này chồng với dòng khác trong file.",
      "BOOKING_CONFLICT": "Khung giờ trùng lịch hiện có.",
      "BOOKING_WARNINGS": "Khung giờ có cảnh báo trùng lịch — import không xác nhận cảnh báo.",
      "BOOKING_FAILED": "Không đặt được lịch với dòng này.",
      "date_in_past": "Không thể nhập lịch vào ngày đã qua.",
      "clinic_closed": "Phòng khám đóng cửa ngày này.",
      "staff_not_working": "Bác sĩ không làm việc ngày này.",
      "staff_all_day_time_off": "Bác sĩ nghỉ phép cả ngày.",
      "schedule_not_configured": "Bác sĩ chưa được cấu hình lịch làm việc.",
      "outside_advance_window": "Ngày này vượt quá giới hạn đặt trước tối đa.",
      "outside_lead_window": "Ngày này nằm trong khoảng thời gian đặt trước tối thiểu."
    }
  },

  "bookingWarnings": {
    "title": "Cảnh báo trùng lịch",
    "body": "Khung giờ này chồng với lịch hẹn khác theo chính sách phòng khám. Bạn vẫn có thể tiếp tục nếu muốn.",
    "confirm": "Vẫn đặt lịch"
  },

  "bookingStatus": {
    "available": "Trống",
    "working": "Có ca làm việc",
    "warn": "Cảnh báo trùng",
    "blocked": "Không đặt được",
    "busy": "Bận",
    "notWorking": "Ngoài giờ làm"
  },

  "status": {
    "scheduled": "Đã đặt lịch",
    "confirmed": "Đã xác nhận",
    "arrived": "Đã tiếp nhận",
    "completed": "Hoàn thành",
    "cancelled": "Đã hủy",
    "noShow": "Không đến",
    "rescheduled": "Đã đổi lịch",
    "unknown": "Không xác định",
    "coreLockedNotice": "Lịch hẹn này đang {{status}}. Các trường chính đã bị khóa; bạn vẫn có thể cập nhật ghi chú."
  },

  "types": {
    "newConsultation": "Tư vấn mới",
    "followUp": "Tái khám",
    "emergency": "Cấp cứu",
    "cleaning": "Làm sạch răng",
    "filling": "Trám răng",
    "rootCanal": "Điều trị tủy",
    "extraction": "Nhổ răng",
    "crownBridgeWork": "Bọc răng/Cầu răng",
    "implant": "Cấy Implant",
    "orthodonticAdjustment": "Chỉnh nha",
    "dentureFitting": "Lắp răng giả",
    "surgicalProcedure": "Phẫu thuật",
    "other": "Khác"
  },

  "catalog": {
    "pages": {
      "title": "Loại lịch hẹn",
      "permissionDenied": "Bạn không có quyền xem danh mục loại lịch hẹn."
    },
    "actions": {
      "add": "Thêm loại",
      "deactivate": "Ngừng dùng",
      "deactivating": "Đang ngừng dùng...",
      "reactivate": "Bật lại",
      "reactivating": "Đang bật lại...",
      "history": "Lịch sử"
    },
    "history": {
      "title": "Lịch sử loại lịch hẹn",
      "empty": "Chưa có lịch sử thay đổi cho loại này."
    },
    "placeholders": {
      "name": "Nhập tên loại lịch hẹn"
    },
    "search": {
      "placeholder": "Tìm loại lịch hẹn..."
    },
    "fields": {
      "name": "Tên",
      "color": "Màu sắc",
      "colorHex": "Mã màu",
      "colorCustom": "Màu tùy chọn",
      "defaultDuration": "Thời lượng mặc định",
      "type": "Kiểu",
      "status": "Trạng thái",
      "dentistOverlap": "Trùng lịch bác sĩ",
      "chairOverlap": "Trùng lịch ghế",
      "policyHint": "Chỉ ghi đè nếu loại này xử lý trùng lịch khác phòng khám."
    },
    "sections": {
      "info": "Thông tin loại",
      "policy": "Luật trùng lịch"
    },
    "form": {
      "name": "Tên loại lịch hẹn"
    },
    "policy": {
      "inherit": "Theo tổ chức/PK",
      "block": "Chặn",
      "warn": "Cảnh báo",
      "allow": "Cho phép"
    },
    "type": {
      "system": "Hệ thống",
      "custom": "Tùy chỉnh"
    },
    "status": {
      "active": "Đang dùng",
      "inactive": "Ngừng dùng"
    },
    "dialogs": {
      "addTitle": "Thêm loại lịch hẹn",
      "editTitle": "Sửa loại lịch hẹn",
      "confirmDeactivate": "Ngừng dùng loại \"{{name}}\"?"
    },
    "table": {
      "code": "Mã",
      "duration": "Thời lượng",
      "policy": "Trùng lịch",
      "policySummary": "BS: {{dentist}} · Ghế: {{chair}}",
      "createdAt": "Ngày tạo",
      "updatedAt": "Cập nhật",
      "createdBy": "Người tạo",
      "updatedBy": "Người cập nhật",
      "actions": "Thao tác",
      "empty": "Chưa có loại lịch hẹn",
      "noFound": "Không tìm thấy loại phù hợp"
    },
    "validation": {
      "nameRequired": "Vui lòng nhập tên loại lịch hẹn",
      "colorInvalid": "Màu sắc phải là mã hex dạng #RRGGBB",
      "defaultDurationInvalid": "Thời lượng mặc định phải là số nguyên từ 15 phút trở lên"
    },
    "toasts": {
      "loadFailed": "Không tải được danh mục loại lịch hẹn",
      "created": "Đã thêm loại lịch hẹn",
      "updated": "Đã cập nhật loại lịch hẹn",
      "deactivated": "Đã ngừng dùng loại lịch hẹn",
      "reactivated": "Đã bật lại loại lịch hẹn",
      "saveFailed": "Không lưu được loại lịch hẹn",
      "deactivateFailed": "Không ngừng dùng được loại lịch hẹn",
      "reactivateFailed": "Không bật lại được loại lịch hẹn"
    }
  },

  "durations": {
    "min15": "15 phút",
    "min30": "30 phút",
    "min45": "45 phút",
    "hour1": "60 phút",
    "hour1Half": "90 phút",
    "hour2": "120 phút"
  },

  "calendar": {
    "weekdays": {
      "mon": "T2",
      "tue": "T3",
      "wed": "T4",
      "thu": "T5",
      "fri": "T6",
      "sat": "T7",
      "sun": "CN"
    },
    "noDoctorsAvailable": "Không có bác sĩ nào để hiển thị.",
    "doctorShortPrefix": "BS",
    "taskFromAppointmentTitle": "Chuẩn bị lịch hẹn",
    "taskFromAppointmentBody": "Lịch hẹn {{code}}",
    "filterByDoctor": "Lọc theo {{name}}",
    "clearDoctorFilter": "Bỏ lọc {{name}}",
    "moreCount": "+{{count}} lịch hẹn khác",
    "previousDay": "Ngày trước",
    "nextDay": "Ngày sau",
    "previousWeek": "Tuần trước",
    "nextWeek": "Tuần sau",
    "previousMonth": "Tháng trước",
    "nextMonth": "Tháng sau",
    "listView": "Xem dạng danh sách",
    "calendarView": "Xem dạng lịch",
    "kanbanView": "Xem dạng Kanban",
    "viewLabel": "Chế độ xem lịch hẹn",
    "emptyColumn": "Không có lịch hẹn",
    "cancelDialogTitle": "Hủy lịch hẹn",
    "cancelDialogConfirm": "Xác nhận hủy",
    "quickStatus": "Đổi trạng thái",
    "time": "Thời gian",
    "selectClinicForAvailability": "Chọn phòng khám (bộ lọc hoặc phạm vi) để xem tình trạng chỗ trống theo chính sách đặt lịch.",
    "slotBlockedToast": "Khung giờ này không thể đặt (trùng lịch hoặc ngoài ca).",
    "slotBusyToast": "Khung giờ này đang bận.",
    "busyBand": "Bận · {{reason}}",
    "slotNotWorkingToast": "Bác sĩ không làm việc trong khung giờ này.",
    "preflightFailed": "Không kiểm tra được khung giờ. Vui lòng thử lại."
  },

  "dialogs": {
    "importTitle": "Nhập lịch hẹn",
    "deleteTitle": "Xóa lịch hẹn",
    "confirmDelete": "Bạn có chắc chắn muốn xóa lịch hẹn của {{name}} vào ngày {{date}} lúc {{time}}? Hành động này không thể hoàn tác.",
    "deleting": "Đang xóa...",
    "quickCreatePatientTitle": "Tạo bệnh nhân nhanh",
    "quickCreateLeadTitle": "Tạo lead nhanh",
    "quickCreateSuccessPatient": "Đã tạo bệnh nhân",
    "quickCreateSuccessLead": "Đã tạo lead",
    "openFullForm": "Mở form đầy đủ",
    "phoneExistsPatient": "Số điện thoại này đã thuộc một bệnh nhân.",
    "phoneExistsLead": "Số điện thoại này đã thuộc một lead đang hoạt động.",
    "selectExistingPatient": "Chọn bệnh nhân này",
    "selectExistingLead": "Chọn lead này",
    "selectExistingFailed": "Không tải được bản ghi đã có. Vui lòng thử lại."
  },

  "fallbacks": {
    "unknownPatient": "Không rõ bệnh nhân",
    "unknownDoctor": "Không rõ bác sĩ",
    "unknownClinic": "Không rõ phòng khám",
    "unknown": "Không rõ",
    "noEmail": "Chưa có email",
    "noEmailAvailable": "Chưa có email",
    "noPhone": "Chưa có số điện thoại",
    "addressNotAvailable": "Địa chỉ không khả dụng",
    "generalSpecialization": "Đa khoa",
    "generalDentistry": "Nha khoa tổng quát",
    "noNotesAvailable": "Chưa có ghi chú",
    "notAvailable": "N/A",
    "selectClinicFirst": "Chọn phòng khám trước"
  },

  "pagination": {
    "rowsPerPage": "Số dòng mỗi trang:",
    "displayedRows": "{{from}}–{{to}} trong {{count}}",
    "moreThan": "hơn {{to}}"
  },

  "activity": {
    "title": "Lịch sử hoạt động",
    "empty": "Chưa có hoạt động nào liên quan đến lịch hẹn này."
  },

  "table": {
    "id": "Mã",
    "patient": "Bệnh nhân / Lead",
    "leadOnly": "Lead",
    "doctor": "Bác sĩ",
    "date": "Ngày hẹn",
    "time": "Giờ hẹn",
    "dateAndTime": "Ngày & Giờ",
    "type": "Loại lịch hẹn",
    "visitKind": "Phân loại lịch",
    "chair": "Ghế",
    "status": "Trạng thái",
    "clinic": "Phòng khám",
    "treatment": "Dịch vụ",
    "treatmentPlan": "Kế hoạch điều trị",
    "reasonForVisit": "Lý do khám",
    "notes": "Ghi chú",
    "followUp": "Tái khám",
    "arrivedAt": "Giờ check-in",
    "checkedInBy": "Người check-in",
    "cancelReason": "Lý do hủy",
    "cancelledBy": "Người hủy",
    "createdBy": "Người tạo",
    "createdAt": "Ngày tạo",
    "updatedBy": "Người sửa",
    "updatedAt": "Ngày sửa"
  },

  "menu": {
    "view": "Xem",
    "edit": "Sửa",
    "delete": "Xóa",
    "history": "Lịch sử"
  },

  "details": {
    "tabs": {
      "info": "Thông tin",
      "activity": "Lịch sử"
    },
    "dateAndTime": "Ngày & Giờ",
    "durationMinutesLabel": "{{count}} phút",
    "patientInfo": "Thông tin bệnh nhân",
    "leadInfo": "Thông tin lead",
    "customerSource": "Nguồn khách hàng:",
    "clinicAndDoctor": "Phòng khám & Bác sĩ",
    "notesAndInfo": "Ghi chú & Thông tin khác",
    "name": "Họ tên:",
    "phone": "Điện thoại:",
    "email": "Email:",
    "date": "Ngày:",
    "time": "Giờ:",
    "duration": "Thời lượng:",
    "type": "Loại:",
    "visitKind": "Phân loại lịch:",
    "chair": "Ghế nha:",
    "clinic": "Phòng khám:",
    "address": "Địa chỉ:",
    "doctor": "Bác sĩ:",
    "specialization": "Chuyên khoa:",
    "reasonForVisit": "Lý do khám:",
    "notes": "Ghi chú:",
    "created": "Ngày tạo:",
    "lastUpdated": "Cập nhật lần cuối:"
  }
}
